import { helpers } from 'vuelidate/lib/validators'

export default () => helpers.withParams(
  { message: 'Invalid CUIT' },
  (value) => {
    if (!helpers.req(value)) return false
    const cuit = value.replace(/[-_]/g, '')
    if (cuit.length !== 11) return false

    const digits = cuit.split('').map(Number)
    const checkDigit = digits.pop()
    const weight = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]

    const sum = digits.reduce((acc, digit, index) => acc + digit * weight[index], 0)
    const mod = 11 - (sum % 11)

    return mod === checkDigit || (mod === 10 && checkDigit === 9)
  }
)
